import {BILLING_PERIOD, getPlanText} from 'MyAccount/AccountPage/PlanAndBilling/Consts';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import DoneIcon from 'material-ui/svg-icons/action/done';
import AddIcon from '@material-ui/icons/Add';
import TimerIcon from 'material-ui/svg-icons/image/timer';
import {orange800} from 'material-ui/styles/colors';
import {couponTypes} from '../helpers/getCouponType';

const imgDays = require('shared/images/30days.svg');
const trustPilot = require('shared/images/trustpilot.svg');
const webRetailer = require('shared/images/webretailer.svg');

const sassStyles = require('./styles.scss');
const styles = {
  radio: {
    display: 'inline-block',
  },
  radioLabel: {
    marginBottom: 0,
    fontSize: 20,
    fontWeight: 300,
  },
  btnSubs: {
    height: 55,
    lineHeight: '55px',
  },
};

class SelectPlan extends React.Component {
  constructor(props) {
    super(props);
    const {selectedBillingPeriod} = props;
    this.state = {
      planIndex: selectedBillingPeriod === BILLING_PERIOD.MONTH ? 3 : 1,
    };
  }

  getPrice = plan => {
    const couponData = this.props.couponStatus.coupon;
    const discountPercent = couponData ? couponData.discountPercent / 100 : 0;

    switch (couponData && couponData.type) {
      case couponTypes.DISCOUNT_MONTHS: {
        const duration = couponData.durationInMonth;
        const months = 12 * plan.years - duration;
        const price = this.roundHalfDown(plan.perMonth * (1 - discountPercent));

        return plan.years > 0 ? (
          <span>
            <span className={sassStyles.greenText}>
              {' '}
              US ${price} x {duration} months
            </span>{' '}
            + US ${plan.perMonth} x {months} months
          </span>
        ) : (
          <span>
            <span className={sassStyles.greenText}>
              {' '}
              US ${price} first {duration} month{duration > 1 ? 's' : ''}
            </span>{' '}
            then US ${plan.perMonth} month to month
          </span>
        );
      }
      case couponTypes.FREE_MONTHS: {
        const duration = couponData.durationInMonth;
        const months = 12 * plan.years - duration;

        return plan.years > 0 ? (
          <span className={sassStyles.greenText}>
            {' '}
            ${plan.perMonth} x {months} months
          </span>
        ) : (
          <span>
            <span className={sassStyles.greenText}>
              {' '}
              US $0 first {duration} month{duration > 1 ? 's' : ''}
            </span>{' '}
            then US ${plan.perMonth} month to month
          </span>
        );
      }
      case couponTypes.LIFETIME: {
        const price = this.roundHalfDown(plan.perMonth * (1 - discountPercent));
        const months = 12 * plan.years;

        return (
          <span className={sassStyles.greenText}>
            {' '}
            US ${price}
            {plan.years > 0 ? ` x US ${months} months` : ' month to month'}
          </span>
        );
      }
      default:
        return ` US $ ${plan.perMonth} ${plan.years > 0 ? `x ${12 * plan.years} months` : 'month to month'}`;
    }
  };

  getTotalPrice({years}) {
    const prices = this.props.couponStatus.allPlansAllPeriodsPrices;
    const {checkedAddOns, planId} = this.props;
    const addOnsPrice = _.sum(_.map(checkedAddOns, ({price}) => price));
    if (_.has(prices, planId)) {
      if (this.state.planIndex !== 1 && addOnsPrice) {
        return prices[planId][years + 1] + (years > 0 ? addOnsPrice * 12 * years : addOnsPrice);
      }
      return prices[planId][years + 1];
    }
    return '';
  }

  getSaveVal({save, years, price}) {
    const couponData = this.props.couponStatus.coupon;
    const discount = couponData ? couponData.discountPercent / 100 : 0;
    const duration = couponData ? couponData.durationInMonth || years * 12 : 0;
    const discountedPrice = price * (1 - discount);
    const roundingDiff = duration * (discountedPrice - this.roundHalfDown(discountedPrice));
    switch (couponData && couponData.type) {
      case couponTypes.DISCOUNT_MONTHS: {
        return this.roundHalfDown(save - (save / (years * 12)) * discount * duration - roundingDiff);
      }
      case couponTypes.FREE_MONTHS: {
        return this.roundHalfDown(save * (1 - duration / (years * 12)) - roundingDiff);
      }
      case couponTypes.LIFETIME: {
        return this.roundHalfDown(save * (1 - discount) - roundingDiff);
      }
      default:
        return save;
    }
  }

  back = () => {
    this.props.back();
  };

  roundHalfDown = price => {
    if ((price * 2) % 1 === 0) {
      return Math.floor(price);
    }
    return Math.round(price);
  };

  render() {
    const {style, plan, show2Year, showBonus, pickPlan, checkedAddOns} = this.props;
    const {planIndex} = this.state;
    const plans = [];
    if (show2Year) {
      plans.push({
        title: '2 Years Subscription',
        years: 2,
        bonusPrice: 0,
        perMonth: Number(plan.twoYearPrice),
        save: Number(plan.switchToTwoYearSave),
        price: Number(plan.price),
        id: 'cla-radio-2-year-subscription',
      });
    }
    if (showBonus) {
      plans.push({
        title: 'Annual Subscription',
        years: 1,
        bonusPrice: Number(plan.annualBonusPrice),
        perMonth: Number(plan.annualPrice),
        save: Number(plan.switchToAnnualWithBonusSave),
        bonuses: plan.bonuses,
        price: Number(plan.price),
        id: 'cla-radio-1-year-with-bonus-subscription',
      });
    }
    plans.push({
      title: 'Annual Subscription',
      perMonth: Number(plan.annualPrice),
      save: Number(plan.switchToAnnualSave),
      bonusPrice: 0,
      years: 1,
      price: Number(plan.price),
      id: 'cla-radio-1-year-subscription',
    });
    plans.push({
      title: 'Monthly Subscription',
      perMonth: Number(plan.price),
      years: 0,
      id: 'cla-radio-monthly-subscription',
    });

    const curPlan = planIndex >= 1 ? plans[planIndex - 1] : undefined;

    return (
      <div className={sassStyles.selectPlan} style={style}>
        <Paper className={sassStyles.box}>
          <div className={sassStyles.title}>Select your {plan.name} plan subscription</div>
          <div className={sassStyles.plans}>
            <RadioButtonGroup
              name="planIndex"
              onChange={(e, planIndex) => this.setState({planIndex})}
              className={sassStyles.radioGroup}
              valueSelected={planIndex}
            >
              {plans.map((plan, index) => (
                <RadioButton
                  id={plan.id}
                  key={index}
                  label={
                    <span>
                      <b>{plan.title}:</b>
                      {this.getPrice(plan)}
                      {plan.bonuses && (
                        <ul className={sassStyles.bonusList}>
                          <li key="offer" className={sassStyles.bonusWarn}>
                            <TimerIcon style={{marginRight: 10}} color={orange800} />
                            <span>Limited time offer!</span>
                          </li>
                          {plan.bonuses.map(bonus => (
                            <li key={bonus}>
                              <DoneIcon style={{marginRight: 10}} />
                              <span>{bonus}</span>
                            </li>
                          ))}
                        </ul>
                      )}
                      {!plan.bonuses && !_.isEmpty(checkedAddOns) > 0 && (
                        <ul className={sassStyles.bonusList}>
                          {_.map(checkedAddOns, ({price}, name) => (
                            <li key={'bullet_' + name}>
                              <AddIcon style={{marginRight: 10}} />
                              <span>
                                {getPlanText(name, price, index === 1 ? BILLING_PERIOD.YEAR : BILLING_PERIOD.MONTH)}
                              </span>
                            </li>
                          ))}
                        </ul>
                      )}
                      {plan.years > 1 ||
                      (!showBonus && plan.years === 1) ||
                      (showBonus && typeof plan.bonuses !== 'undefined') ? (
                        <div className={sassStyles.arrowWrap}>
                          <div className={sassStyles.arrow}>{`Save $${this.getSaveVal(plan)}`}</div>
                        </div>
                      ) : null}
                    </span>
                  }
                  style={styles.radio}
                  className={sassStyles.plan}
                  value={index + 1}
                  labelStyle={styles.radioLabel}
                />
              ))}
            </RadioButtonGroup>
          </div>
          {curPlan && (
            <div className={sassStyles.tip}>
              You'll be taken to paypal to pay <b> US ${this.getTotalPrice(curPlan)}</b>
            </div>
          )}
          <div className={sassStyles.buttons}>
            <FlatButton id="cla-btn-back" label="Back" onClick={this.back} />
            <RaisedButton
              id="cla-btn-select-subscription"
              label={'Select Subscription'.toUpperCase()}
              style={styles.btnSubs}
              primary
              onClick={() => pickPlan(plans[planIndex - 1].years, typeof plans[planIndex - 1].bonuses !== 'undefined')}
            />
          </div>
        </Paper>
        <div className={sassStyles.images}>
          <div className={sassStyles.imagesBlock}>
            <img src={imgDays} alt="30 Day Money Back Guarantee" width="324px" />
          </div>
          <a
            href="https://www.trustpilot.com/review/crazylister.com"
            target="_blank"
            className={sassStyles.imagesBlock}
          >
            <img src={trustPilot} alt="TrustPilot" width="205px" />
          </a>
          <a
            href="http://www.webretailer.com/profiles/crazylister.asp"
            target="_blank"
            className={sassStyles.imagesBlock}
          >
            <img src={webRetailer} alt="WebRetailer" width="235px" />
          </a>
        </div>
      </div>
    );
  }
}

SelectPlan.propTypes = {
  pickPlan: PropTypes.func,
  planId: PropTypes.string,
  selectedBillingPeriod: PropTypes.number,
};

SelectPlan.defaultProps = {
  back: callback => callback(),
};

export default SelectPlan;
